import {
  ECardTypeTemplateId,
  type TCardTypeAdditionalInfoType,
  type TCardTypeTemplate,
} from 'types/cardTypeMessage';

export const CARD_TYPE_TEMPLATES: TCardTypeTemplate[] = [
  {
    id: ECardTypeTemplateId.Products,
    label: 'Products',
    description:
      'Tag, images, header, description, price, 2 actions (carousel, up to 9 cards)',
  },
  {
    id: ECardTypeTemplateId.Places,
    label: 'Places',
    description:
      'Tag, images, header, address, additional info, 2 actions (carousel, up to 9 cards)',
  },
  {
    id: ECardTypeTemplateId.People,
    label: 'People',
    description:
      '3 tags, image, name, description, 2 actions (carousel, up to 9 cards)',
  },
  {
    id: ECardTypeTemplateId.Pictures,
    label: 'Pictures',
    description: 'Tag, image, 1 action per card (carousel, up to 9 cards)',
  },
];

export const CARD_TYPE_TEMPLATE_MAP = new Map(
  CARD_TYPE_TEMPLATES.map((t) => [t.id, t]),
);

export function getCardTypeTemplate(
  id: string | undefined,
): TCardTypeTemplate | undefined {
  if (!id) return undefined;
  return CARD_TYPE_TEMPLATE_MAP.get(id as ECardTypeTemplateId);
}

/** LINE OAM allows up to 9 cards in a card-type carousel. */
export const CARD_TYPE_MAX_CARDS = 9;

/** LINE Flex Message limits used by card-type messages. */
export const CARD_TYPE_ALT_TEXT_MAX_LENGTH = 1500;
export const CARD_TYPE_MESSAGE_ACTION_TEXT_MAX_LENGTH = 300;
export const CARD_TYPE_URI_MAX_LENGTH = 1000;

export const CARD_TYPE_IMAGE_ACCEPTED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
] as const;
export const CARD_TYPE_IMAGE_ACCEPT_ATTRIBUTE =
  CARD_TYPE_IMAGE_ACCEPTED_MIME_TYPES.join(',');
export const CARD_TYPE_IMAGE_MAX_BYTES = 10 * 1024 * 1024;
export const CARD_TYPE_IMAGE_MAX_DIMENSION = 1024;

export const CARD_TYPE_PREVIEW_HEIGHT = 350;
export const CARD_TYPE_PREVIEW_IMAGE_HEIGHT = 176;

export type TCardTypeImageRecommendationKey =
  | 'productsPlacesSingle'
  | 'productsPlacesDouble'
  | 'productsPlacesTriple'
  | 'square';

export function getCardTypeImageRecommendationKey(
  templateId: ECardTypeTemplateId,
  imageCount: 1 | 2 | 3,
): TCardTypeImageRecommendationKey {
  if (
    templateId === ECardTypeTemplateId.Products ||
    templateId === ECardTypeTemplateId.Places
  ) {
    if (imageCount === 1) return 'productsPlacesSingle';
    if (imageCount === 2) return 'productsPlacesDouble';
    return 'productsPlacesTriple';
  }

  return 'square';
}

export const CARD_TYPE_ADDITIONAL_INFO_TYPES: readonly TCardTypeAdditionalInfoType[] =
  ['Hours', 'Price'];

export const CARD_TYPE_ADDITIONAL_INFO_ICONS: Record<
  TCardTypeAdditionalInfoType,
  string
> = {
  Hours: '🕐',
  Price: '💰',
};

export function normalizeAdditionalInfoType(
  value: string | undefined,
): TCardTypeAdditionalInfoType {
  return value === 'Price' ? 'Price' : 'Hours';
}

export function getAdditionalInfoPreviewIcon(
  infoType: string | undefined,
): string {
  return CARD_TYPE_ADDITIONAL_INFO_ICONS[normalizeAdditionalInfoType(infoType)];
}
